import React, { useState } from "react";
import { Statistic, Checkbox } from "antd";
import { useSelector } from "react-redux";
import ExpandedRowRender from "./TablesInfoSecondTable";
import { useProjectState } from "../../../context/stateContext";

const TablesInfoMainTable = () => {
  const [openedTables, setOpenedTables] = useState(true);
  const [closedTables, setClosedTables] = useState(true);
  const { tables } = useSelector((state) => state.tablesInfoReducer);
  const { allSectedRestaurants } = useProjectState();

  const restaurantData = tables.filter(
    (table) => table.restaurantId === allSectedRestaurants[0]
  )[0];

  return (
    <>
      <div className="table-info-selected-restaurant-info">
        <Statistic
          valueStyle={{ fontSize: "15px", textAlign: "center" }}
          title={
            <Checkbox
              checked={openedTables}
              onChange={() => setOpenedTables(!openedTables)}
            >
              Отворени
            </Checkbox>
          }
          value={
            restaurantData?.openTablesCount !== undefined
              ? `${
                  restaurantData.openTablesCount
                } / ${restaurantData.openTablesTotalSum.toFixed(2)} €`
              : "0 / 0.00 €"
          }
        />
        <Statistic
          valueStyle={{ fontSize: "15px", textAlign: "center" }}
          title={
            <Checkbox
              checked={closedTables}
              onChange={() => setClosedTables(!closedTables)}
            >
              Затворени
            </Checkbox>
          }
          value={
            restaurantData?.closedTablesCount
              ? `${
                  restaurantData.closedTablesCount
                } / ${restaurantData.closedTablesTotalSum.toFixed(2)} €`
              : "0 / 0.00 €"
          }
        />
      </div>
      <ExpandedRowRender
        row={restaurantData}
        openedTables={openedTables}
        closedTables={closedTables}
      />
    </>
  );
};

export default TablesInfoMainTable;
